module.exports = "/images/SS_Logo White.png?3aa8aa4fa3f2fc061d082305a67f6c5e";